<template>
  <div class="container-xl" v-if="!window.hide_header">
    <div class="header bg-solid position-relative">
      <div class="row">
        <div class="col">
          <itinerary-adv-form :forceAdvView=true></itinerary-adv-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ItineraryAdvForm from "../components/forms/itinerary-adv-form-module";

export default {
  name: 'section-header-form-adv',
  components: {
    ItineraryAdvForm
  },
  data() {
    return {}
  }
}
</script>